import { useUnit } from 'effector-react';
import { useProductParams } from '../../../../hooks/useProductParams';
import { useTranslation } from 'react-i18next';

import { $cartState } from '../../../../store/models/cart';
import { EProducts, EProductSizes } from '../../../../model/enums';

import styles from './styles.module.scss';

const InfoSection = () => {
  const { t } = useTranslation();
  const { productType } = useProductParams();
  const { selectedProductSize } = useUnit($cartState);
  let content = null;

  switch (productType) {
    case EProducts.grs:
      content = (
        <>
          <p
            dangerouslySetInnerHTML={{
              __html: t(`infoSection.${selectedProductSize}.txt0`),
            }}
          ></p>
          <p
            dangerouslySetInnerHTML={{
              __html: t(`infoSection.${selectedProductSize}.txt1`),
            }}
          ></p>
          {selectedProductSize === EProductSizes.standard && (
            <p
              dangerouslySetInnerHTML={{
                __html: t(`infoSection.${selectedProductSize}.txt2`),
              }}
            ></p>
          )}
          <p
            dangerouslySetInnerHTML={{
              __html: t(`infoSection.${selectedProductSize}.txt3`),
            }}
          ></p>
        </>
      );
      break;
    case EProducts.acs:
      content = (
        <>
          <p>{t('plasicTrayInfo.main')}</p>
          <p>{t('plasicTrayInfo.txt1')}</p>
          <p>1. {t('plasicTrayInfo.txt2')}</p>
          <p>2. {t('plasicTrayInfo.txt3')}</p>
          <p>3. {t('plasicTrayInfo.txt4')}</p>
        </>
      );
      break;
    case EProducts.ctn:
      content = (
        <>
          <p>{t('catnipInfo.txt1')}</p>
          <p
            dangerouslySetInnerHTML={{
              __html: t(`catnipInfo.txt2`),
            }}
          ></p>
          <p>
            <strong>{t('catnipInfo.txt3')}</strong>
          </p>
          <p>{t('catnipInfo.txt4')}</p>
        </>
      );
      break;
    case EProducts.sds:
      content = <div>{t('catgrassSeedsInfo.txt')}</div>;
      break;
    default:
      content = <span>Unknown product info</span>;
      break;
  }

  return <div className={styles.infoSection}>{content}</div>;
};

export default InfoSection;
